var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert",class:_vm.flash.type},[_c('span',{staticClass:"icon white-cross-sm-icon",on:{"click":_vm.remove}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.flash.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }